
import { mapGetters } from 'vuex';

export default {
    props: {
        items: { type: Array, required: true },
        activeSlideIndex: { type: Number, required: true },
        restaurant: { type: Object, required: true },
    },
    data: t => ({
        swiperSettings: {
            slidesPerView: 1,
            initialSlide: t.activeSlideIndex,
            // pagination: {
            //     el: '.swiper-pagination',
            //     type: 'bullets',
            // },
        },
    }),
    computed: {
        ...mapGetters('order', ['itemsCount', 'restaurantLocation']),
        restaurantName() {
            return this.restaurant.name;
        },
    },
};
